import * as React from 'react';
export var TimelineItem = function (_a) {
    var icon = _a.icon, children = _a.children;
    return (React.createElement("li", null,
        React.createElement("div", { className: "timeline-badge text-center" },
            React.createElement("i", { className: icon })),
        React.createElement("div", { className: "timeline-panel" }, children)));
};
//# sourceMappingURL=TimelineItem.js.map